const data = {
  'Selected': 'Terpilih: {0} of {1}',
  'Uploading files': 'Mengunggah {0}% of {1}',
  'File size error': '{0} file terlalu besar, harap unggah file lebih kecil dari {1}',
  'Upload failed': '{0} gagal diunggah',
  'Per page': '{0} Per Halaman',
  'Folder': 'Berkas',
  'Login failed, please try again': 'Gagal masuk, silakan coba lagi',
  'Already logged in': 'Telah masuk.',
  'Please enter username and password': 'Silahkan masukan nama pengguna dan kata sandi.',
  'Not Found': 'Tidak ditemukan',
  'Not Allowed': 'Tidak dibolehkan',
  'Please log in': 'Silahkan masuk',
  'Unknown error': 'Kesalahan tidak dikenal',
  'Add files': 'Tambahkan berkas',
  'New': 'Baru',
  'New name': 'Nama baru',
  'Username': 'Nama pengguna',
  'Password': 'Kata sandi',
  'Login': 'Masuk',
  'Logout': 'Keluar',
  'Profile': 'Profil',
  'No pagination': 'Tidak ada halaman',
  'Time': 'Waktu',
  'Name': 'Nama',
  'Size': 'Ukuran',
  'Home': 'Rumah',
  'Copy': 'Salin',
  'Move': 'Pindah',
  'Rename': 'Ubah nama',
  'Required': 'Silakan isi bidang ini',
  'Zip': 'Zip',
  'Batch Download': 'Unduh Batch',
  'Unzip': 'Unzip',
  'Delete': 'Hapus',
  'Download': 'Unduh',
  'Copy link': 'Salin tautan',
  'Done': 'Selesai',
  'File': 'File',
  'Drop files to upload': 'Letakkan file untuk diunggah',
  'Close': 'Tutup',
  'Select Folder': 'Pilih Berkas',
  'Users': 'Pengguna',
  'Files': 'Arsip',
  'Role': 'Peran',
  'Cancel': 'Batal',
  'Paused': 'Dijeda',
  'Confirm': 'Konfirmasi',
  'Create': 'Buat',
  'User': 'Pengguna',
  'Admin': 'Admin',
  'Save': 'Simpan',
  'Read': 'Baca',
  'Write': 'Tulis',
  'Upload': 'Unggah',
  'Permissions': 'Izin',
  'Homedir': 'Beranda direktori',
  'Leave blank for no change': 'Biarkan kosong tanpa perubahan',
  'Are you sure you want to do this?': 'Anda yakin ingin melakukan ini?',
  'Are you sure you want to allow access to everyone?': 'Apakah anda yakin ingin mengizinkan akses ke semua orang?',
  'Are you sure you want to stop all uploads?': 'Apakah anda yakin ingin menghentikan semua unggahan?',
  'Something went wrong': 'Ada yang salah',
  'Invalid directory': 'Direktori salah',
  'This field is required': 'Bagian ini diperlukan',
  'Username already taken': 'Nama pengguna sudah digunakan',
  'User not found': 'Pengguna tidak ditemukan',
  'Old password': 'Kata sandi lama',
  'New password': 'Kata sandi baru',
  'Wrong password': 'Kata sandi salah',
  'Updated': 'Diperbarui',
  'Deleted': 'Dihapus',
  'Your file is ready': 'File Anda sudah siap',
  'View': 'Lihat',
  'Search': 'Cari',
  'Download permission': 'Unduh',
  'Guest': 'Tamu',
  'Show hidden': 'Tunjukkan tersembunyi',
}

export default data
